import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { Observer, observer } from "mobx-react-lite";
import ReportingViewModel from "../../../viewModels/timeCharges/reporting/reportingViewModel";

const ReportingView: ViewComponent<ReportingViewModel> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(ReportingView, ReportingViewModel);
